import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { EditorCell } from "../cells/editorCell";
import { ImgCell } from "../cells/imgCell";
import { TextCell } from "../cells/textCell";
import { Close as CloseIcon } from '@material-ui/icons';
import { calcolaPrezzoLavorazione, calcolaScontoTabellaLavorazioni, calcolaTotParziale } from "../../../utils/functionsUtils";

const Wrapper = styled.div`

    & {
        width: 100%;
        max-width: 100%;

        display: flex;
        flex-direction: row;
        align-items: normal;

        background-color: var(--white);
        border-bottom: 1px solid var(--grey-1);
        
        
    }

    & > div {
        display: flex;
        justify-content: center;
        border-right: 1px solid var(--grey-1);
        padding-top: 0px;
        padding-bottom: 0px;
    }

    & > .cell-padding {
        padding-left: 16px;
        padding-right: 16px;
    }

    & > div:nth-last-child(1) {
        border-right: 0px;
    }

`;

/**
 *
 * @param {} elements
 * @param {} orderingListener
 * @returns
 */
export const RowCommesseAltreLavorazioni = (props) => {

    const [data, setData] = useState(props.data);

    useEffect(() => {
        setData(props.data);
    }, [props.data]);

    const onChange = (id, value, isValid) => {

    }

  return (
        <Wrapper
            className={props.className}
            style={props.style}
        >
            <EditorCell
                id={"data1"}
                value={data.ua}
                lightbackground
                noborder={"true"}
                type="text"
                padding="0px !important"
                onChange={(id, value) => {
                    data.ua = value;
                    setData({ ...data });
                    if(props.onChange) {
                        props.onChange(data);
                    }
                }}
                style={{
                    width: "5.956%",
                    padding: "0px"
                }}
            />

            <EditorCell
                id={"data2"}
                value={data.ua_value}
                lightbackground
                noborder={"true"}
                type="text"
                padding="0px !important"
                onChange={(id, value) => {
                    data.ua_value = value.replace(",", ".");
                    setData({ ...data });
                    if(props.onChange) {
                        props.onChange(data);
                    }
                }}
                style={{
                    width: "8.956%",
                    padding: "0px"
                }}
            />

            <EditorCell
                id={"data3"}
                value={data.descrizione}
                lightbackground
                noborder={"true"}
                type="text"
                padding="0px !important"
                onChange={(id, value) => {
                    data.descrizione = value;
                    setData({ ...data });
                    if(props.onChange) {
                        props.onChange(data);
                    }
                }}
                style={{
                    width: "29.912%",
                    padding: "0px"
                }}
            />


            {/* <EditorCell
                id={"data4"}
                value={data.mat}
                lightbackground
                noborder={"true"}
                type="text"
                padding="0px !important"
                onChange={(id, value) => {
                    data.mat = value;
                    setData({ ...data });
                    if(props.onChange) {
                        props.onChange(data);
                    }
                }}
                style={{
                    width: "6.956%",
                    padding: "0px"
                }}
            /> */}

            <select name="select_suppl" id="select_suppl" 
                style={{
                    width: "6.956%",
                    border: "none",
                    borderRight: "1px solid var(--grey-1)"
                }}
                value={`${data.suppl}`}
                onChange={(e) => {
                    data.suppl = e.target.value;
                    setData({ ...data });
                    if(props.onChange) {
                        props.onChange(data);
                    }
                }}
            >
                <option value="true">SI</option>
                <option value="false">NO</option>
            </select>
            
            
            <EditorCell
                id={"data6"}
                value={data.note}
                lightbackground
                noborder={"true"}
                type="text"
                padding="0px !important"
                onChange={(id, value) => {
                    data.note = value;
                    setData({ ...data });
                    if(props.onChange) {
                        props.onChange(data);
                    }
                }}
                style={{
                    width: "23.956%",
                    padding: "0px"
                }}
            />

            <EditorCell
                id={"data7"}
                value={data.prezzo}
                lightbackground
                noborder={"true"}
                type="text"
                padding="0px !important"
                onChange={(id, value) => {
                    data.prezzo = value.replace(",", ".");
                    setData({ ...data });
                    if(props.onChange) {
                        props.onChange(data);
                    }
                }}
                style={{
                    width: "8.956%",
                    padding: "0px"
                }}
            />

            {/* <EditorCell
                id={"data8"}
                value={data.sc}
                lightbackground
                noborder={"true"}
                type="text"
                padding="0px !important"
                onChange={(id, value) => {
                    data.sc = value.replace(",", ".");
                    setData({ ...data });
                    if(props.onChange) {
                        props.onChange(data);
                    }
                }}
                style={{
                    width: "8.956%",
                    padding: "0px"
                }}
            /> */}

            <TextCell
                primaryText={data.prezzo != "" && data.ua_value != "" && data.sc != "" ? calcolaTotParziale(calcolaPrezzoLavorazione(data.prezzo, data.ua_value), data.sc) : ""}
                primaryTextSize="small"
                color="var(--black)"
                className="cell-padding"
                style={{
                    width: "8.956%",
                    padding: "0px"
                }}
            />
        
            <div
                className="cell-padding"
                style={{
                    width: "4.35%",
                    alignItems: "center"
                }}
            >

                <CloseIcon
                    onClick={() => {
                        if(props.onDelete) {
                            props.onDelete(data);
                        }
                    }}
                    style={{
                        width: "20px",
                        height: "20px",
                        cursor: "pointer"
                    }}
                />

            </div>

        </Wrapper>
  );
};
